import { FormaDesembolsoService } from './../../../_services/forma-desembolso.service';
import { sleep } from '../../../utils/utilidades';
import { NavService } from './../../../_services/_nav.service';
import { ProductoPlanCargoService } from './../../../_services/producto-plan-cargo.service';
import { ProductoPlanCargo } from './../../../_models/producto-plan-cargo';
import { PlanCargo } from './../../../_models/plan-cargo';
import { PlanCargoService } from './../../../_services/plan-cargo.service';
import { Producto } from './../../../_models/producto';
import { Component, OnInit, Input } from '@angular/core';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormaDesembolso } from './../../../_models/forma-desembolso';

@Component({
  selector: 'app-producto-planes-cargos',
  templateUrl: './producto-planes-cargos.component.html',
  styleUrls: ['./producto-planes-cargos.component.css'],
})
export class ProductoPlanesCargosComponent implements OnInit {
  @Input() producto: Producto;
  esDetalle = false;
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  carTabla = true;
  columnas = [];

  planesCargos: PlanCargo[] = [];
  lisPlanesCargos: SelectItem[] = [];
  lisProductoPlanesCargos: ProductoPlanCargo[] = [];
  lisProductoPlanesCargosTodos: ProductoPlanCargo[] = [];
  lisProductoPlanesCargosTodos2: ProductoPlanCargo[] = [];
  lisFormaDesembolso: SelectItem[] = [];
  lisFormaDesembolsoTodos: FormaDesembolso[] = [];
  constructor(
    private planCargoService: PlanCargoService,
    private productoPlanCargoService: ProductoPlanCargoService,
    private forDesembolsoServicio: FormaDesembolsoService,
    private fb: FormBuilder,
    private navServicio: NavService,
    private conServicio: ConfirmationService
  ) {}

  ngOnInit() {
    this.cargaInicial();
  }

  cargaInicial() {
    this.planesCargos = [];
    this.lisProductoPlanesCargosTodos = [];
    this.lisProductoPlanesCargosTodos2 = [];
    this.lisProductoPlanesCargos = [];
    forkJoin(
      this.planCargoService.listado(),
      this.productoPlanCargoService.listadoPorProducto(this.producto.idProducto),
      this.forDesembolsoServicio.listadoHabilitado()
      ).toPromise().then(([
        planesCargos,
        productosPlanesCargos,
        formasDesembolso
      ]) => {
        this.lisFormaDesembolsoTodos = formasDesembolso;
        this.planesCargos = planesCargos;
        this.lisProductoPlanesCargosTodos = productosPlanesCargos;
        let cont = 0;
        productosPlanesCargos.map(element => {
          this.lisProductoPlanesCargosTodos2[cont] = Object.assign({}, element);
          cont++;
        });
        // this.lisProductoPlanesCargosTodos2 = Object.assign([], this.lisProductoPlanesCargosTodos);

        this.lisProductoPlanesCargos = this.lisProductoPlanesCargosTodos.filter(
          (x) => x.indicadorHabilitado
        );

        /*this.planesCargos.map((plan) => {
          this.lisPlanesCargos.push({
            label: plan.nombre,
            value: plan.idPlanCargo,
          });
        }); */
        this.validarLista();
        this.cargarFormaDesembolso();
        this.setearColumnas();
        this.cargarFormulario();
      });
  }

  async refrescarProductosPlanesCargos() {
    this.guardando = true;
    this.carInformacionInicial = true;
    this.carTabla = true;
    this.lisProductoPlanesCargosTodos = await this.productoPlanCargoService.listadoPorProducto(this.producto.idProducto).toPromise();
    let cont = 0;
    this.lisProductoPlanesCargosTodos.map(element => {
      this.lisProductoPlanesCargosTodos2[cont] = Object.assign({}, element);
      cont++;
    });
    this.lisProductoPlanesCargos = this.lisProductoPlanesCargosTodos.filter(
      (x) => x.indicadorHabilitado
    );
    this.cargarFormulario();
    this.carInformacionInicial = false;
    this.guardando = false;
    this.carTabla = false;
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idProducto: [this.producto ? this.producto.idProducto : null],
      idPlanCargo: [null, [Validators.required]],
      idFormaDesembolso: [null, [Validators.required]],
      indicadorDigital: [false],
      indicadorTradicional: [false],
      indicadorDefault: [false],
      indicadorHabilitado: [true],
    });
    this.carInformacionInicial = false;
    this.guardando = false;
    this.carTabla = false;
  }

  cargarFormaDesembolso() {
    this.lisFormaDesembolso = [];
    this.lisFormaDesembolsoTodos.map( ( s: FormaDesembolso ) => {
        this.lisFormaDesembolso.push( { label: s.nombre, value: s.idFormaDesembolso } );
    } );
  }

  /* validar y llenar las listas necesarias */
  validarLista() {
    this.lisPlanesCargos = [];
    this.planesCargos.map((x) => {
      this.lisPlanesCargos.push({ label: x.nombre, value: x.idPlanCargo });
    });
  }

  setearColumnas() {
    this.columnas = [
      {
        field: 'formaDesembolso',
        header: this.navServicio.buscarMensaje('PRODUCTOPLANCARGO.LBL_TIPOESPECIE'),
        sort: false,
      },
      {
        field: 'nombre-plan-cargo',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOPLANCARGO.LBL_PLANCARGO'
        ),
        sort: false,
      },
      {
        field: 'indicadorDigital',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOPLANCARGO.LBL_INDICADIGITAL'
        ),
        sort: false,
      },
      {
        field: 'indicadorTradicional',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOPLANCARGO.LBL_INDICATRADICIONAL'
        ),
        sort: false,
      },
      {
        field: 'indicadorPredeterminado',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOPLANCARGO.LBL_INDICAPREDETERMINADO'
        ),
        sort: false,
      },
      {
        field: 'det',
        header: this.navServicio.buscarMensaje('LBL_ACCIONES'),
        sort: false,
      },
    ];
  }

  async onSubmit() {
    this.submitted = true;
    this.guardando = true;
    const registro = this.formulario.value;
    if (this.formulario.valid && await this.validarIndicadorPredeterminado(registro) &&
      await this.validarIndicadoresTradicionalDigital(registro, true)) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje(
          'PRODUCTOPLANCARGO.MSG_CONFGUARDADO'
        ),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        key: 'planes-cargos',
        accept: async () => {
          await this.guardarProductoPlanCargo(registro);
        },
        reject: () => {
          this.submitted = false;
          this.guardando = false;
        },
      });
    } else {
      this.guardando = false;
    }
  }

  async guardarProductoPlanCargo(registro: ProductoPlanCargo) {
    const existe = this.lisProductoPlanesCargosTodos.find(
      (x) => x.idPlanCargo === registro.idPlanCargo &&
      x.idFormaDesembolso === registro.idFormaDesembolso
    );
    if (!existe) {
      this.productoPlanCargoService.crear(registro).subscribe(
        (res) => {
          this.navServicio.setMesage(2);
          this.formulario.reset();
          this.submitted = false;
          // this.cargaInicial();
          this.refrescarProductosPlanesCargos();
        },
        (error) => {
          this.navServicio.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        }
      );
    } else {
      registro.idProductoPlanCargo = existe.idProductoPlanCargo;
      registro.indicadorHabilitado = true;
      this.productoPlanCargoService.actualizar(registro).subscribe(
        (res) => {
          this.navServicio.setMesage(2);
          this.formulario.reset();
          this.submitted = false;
          // this.cargaInicial();
          this.refrescarProductosPlanesCargos();
        },
        (error) => {
          this.navServicio.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        }
      );
    }
  }

  async validarIndicadorPredeterminado(registro: ProductoPlanCargo) {
    if (registro.indicadorDefault) {
      const existe = this.lisProductoPlanesCargosTodos2.find((x) => x.indicadorDefault);
      if (!existe || (existe && existe.idProductoPlanCargo === registro.idProductoPlanCargo)) {
        return true;
      }
      this.navServicio.setMesage(0, {
        severity: 'info',
        summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje(
          'PRODUCTOPLANCARGO.MSG_ERRORPREDETERMINADO'
        ),
      });
      // this.cargaInicial();
      this.refrescarProductosPlanesCargos();
      return false;
    } else {
      return true;
    }
  }

  async validarIndicadoresTradicionalDigital(registro: ProductoPlanCargo, creando = false) {
    if (!registro.indicadorTradicional && !registro.indicadorDigital && !registro.indicadorDefault) {
      // Mensaje
      this.navServicio.setMesage(0, {
        severity: 'info',
        summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje(
          'PRODUCTOPLANCARGO.MSG_ERRORINDICADORES'
        ),
      });
      // this.cargaInicial();
      this.refrescarProductosPlanesCargos();
      return false;
    }

    const existente = this.lisProductoPlanesCargosTodos2.find((x) =>
    (x.idFormaDesembolso === registro.idFormaDesembolso && x.idPlanCargo === registro.idPlanCargo));
    if (existente && existente.indicadorHabilitado && creando) {
      this.navServicio.setMesage(0, {
        severity: 'info',
        summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje(
          'PRODUCTOPLANCARGO.MSG_ERRORINDICADORES'
        ),
      });
      return false;
    }
    const existe = this.lisProductoPlanesCargosTodos2.find((x) =>
      (x.idFormaDesembolso === registro.idFormaDesembolso && x.idProductoPlanCargo !== registro.idProductoPlanCargo && x.indicadorHabilitado
        && ((registro.indicadorDigital && x.indicadorDigital) ||
      (registro.indicadorTradicional && x.indicadorTradicional) ||
      (registro.indicadorDefault && x.indicadorDefault))));

    if (!existe) {
      return true;
    }
    this.navServicio.setMesage(0, {
      severity: 'info',
      summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
      detail: this.navServicio.buscarMensaje(
        'PRODUCTOPLANCARGO.MSG_ERRORINDICADORES'
      ),
    });
    // this.cargaInicial();
    this.refrescarProductosPlanesCargos();
    return false;
  }

  /* controls del formulario */
  get f() {
    return this.formulario.controls;
  }

  /* inhabilitar el registro */
  async habilitarInhabilitar(row: ProductoPlanCargo, event: boolean, indicador: string,  habilitado = true) {
    this.guardando = true;
    if (await this.validarIndicadorPredeterminado(row) && await this.validarIndicadoresTradicionalDigital(row)) {
      this.guardando = true;
      row.indicadorHabilitado = habilitado;
      if (!habilitado) {
        row.indicadorDefault = false;
      }
      this.productoPlanCargoService.actualizar(row).subscribe(
        (res) => {
          this.navServicio.setMesage(2);
          this.formulario.reset();
          this.submitted = false;
          // this.cargaInicial();
          this.refrescarProductosPlanesCargos();
        },
        (error) => {
          this.navServicio.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        }
      );
    } else {
      // row[indicador] = !event;
      // this.carTabla = false;
      // this.guardando = false;
      this.refrescarProductosPlanesCargos();
    }
  }

  regresarFormulario( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'planes-cargos',
        accept: () => {
          this.formulario.reset();
          this.f.idProducto.setValue( this.producto.idProducto );
          this.f.indicadorHabilitado.setValue( true );
          this.submitted = false;
        },
        reject: () => {
        }
      } );
    } else {
      this.formulario.reset();
      this.f.idProducto.setValue( this.producto.idProducto );
      this.f.indicadorHabilitado.setValue( true );
      this.submitted = false;
    }
  }
}
